import React from 'react'
import blog from '../../api/blog'
// import { getBlogs } from "../../api/blogs";
import SectionTitle3 from '../SectionTitle3'
import {Link} from 'react-router-dom'
import bShape1 from '../../images/blog/Vector3.png'
import bShape2 from '../../images/blog/Vector4.png'
// Import blog images
import maakResidence2 from '../../images/projects/maak-residence-2.jpg';
import aizelTowerWarsan1 from '../../images/projects/aizel-tower-warsan-1.jpg';
import maakResidence1 from '../../images/projects/maak-residence-1.jpg';

const BlogSectionS2 = (props) => {
    
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(

        <section className="wpo-blog-section-s2 section-padding" id="blog">
            <div className="container">
                <SectionTitle3 subTitle={'Our Blog'} MainTitle={'Our Latest News'}/>
                <div className="wpo-blog-items">
                    <div className="row">
                        {blog.slice(0,3).map((blog, Bitem) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={Bitem}>
                                <div className="wpo-blog-item">
                                    <div className="wpo-blog-img">
                                        {blog.id === '1' && <img src={maakResidence2} alt=""/>}
                                        {blog.id === '2' && <img src={maakResidence1} alt=""/>}
                                        {blog.id === '3' && <img src={aizelTowerWarsan1} alt=""/>}
                                        <div className="thumb">{blog.thumb}</div>
                                    </div>
                                    <div className="wpo-blog-content">
                                        <ul>
                                            <li>{blog.create_at}</li>
                                            <li>By <Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.author}</Link></li>
                                        </ul>
                                        <h2><Link onClick={ClickHandler} to={`/blog-single/${blog.id}`}>{blog.title}</Link></h2>
                                        <p>{blog.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="vector-1">
                <img src={bShape1} alt=""/>
            </div>
            <div className="vector-2">
                <img src={bShape2} alt=""/>
            </div>
        </section>
    )
}

export default BlogSectionS2;